<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>
      <basic-table
        :items="services"
        :fields="servicesFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        account_id: 0,
        accounting_period_id: 0
      },
      services: [],
      servicesFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'service_name', label: this.$i18n.t('Service name'), sortable: true},
        {key: 'nameServices', label: this.$i18n.t('Type name'), sortable: true},
        {key: 'date', label: this.$i18n.t('Sharge time'), sortable: true},
        {key: 'accounting_period_id', label: this.$i18n.t('Accounting period'), sortable: true},
        {key: 'charge', label: this.$i18n.t('Volume'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      filterOptions: {
        isFilterGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async load () {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart

      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_SERVICES', this.getStore).then(response => {
        this.services = this.$store.getters['Reports/SERVICES']
        for (let el of this.services) {
          el.date = moment(Number(el.date) * 1000).format('MM-DD-YYYY')
          switch (el.service_type) {
            case 1:
              el.nameServices = this.$i18n.t('One-time service link')
              break
            case 2:
              el.nameServices = this.$i18n.t('Periodic service link')
              break
            case 3:
              el.nameServices = this.$i18n.t('IP traffic service link')
              break
            case 4:
              el.nameServices = this.$i18n.t('Hots pot service link')
              break
            case 5:
              el.nameServices = this.$i18n.t('Dial-up service link')
              break
            case 6:
              el.nameServices = this.$i18n.t('Telephony service link')
              break
            case 8:
              el.nameServices = this.$i18n.t('IPTV service link')
              break
            case 9:
              el.nameServices = this.$i18n.t('Video service link')
              break
          }
        }
      })
      this.loadDone()
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/services/main.vue